import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IMessage extends IModel {
	content?: string;
	messageChannelKey?: string;
}

const messageFactory = modelFactory.createFactory<IMessage>('Message', _.assign({}, model, {
	content: {
		rules: validator.required()
	},
	messageChannelKey: {
		setFilters: valueFilters.clean
	}
}));

export default messageFactory;